//#region src/payment_processor.ts
let PaymentProcessor = /* @__PURE__ */ function(PaymentProcessor) {
	PaymentProcessor["Adyen"] = "Adyen";
	PaymentProcessor["Chase"] = "Chase";
	PaymentProcessor["Eigen"] = "Eigen";
	PaymentProcessor["Elavon"] = "Elavon";
	PaymentProcessor["FirstDataNashville"] = "FirstData Nashville";
	PaymentProcessor["FirstDataNorth"] = "FirstData North (RapidConnect)";
	PaymentProcessor["FirstDataTampa"] = "FirstData Tampa";
	PaymentProcessor["GlobalCanada"] = "Global Canada";
	PaymentProcessor["Global"] = "Global US";
	PaymentProcessor["Heartland"] = "Heartland";
	PaymentProcessor["Moneris"] = "Moneris";
	PaymentProcessor["OloPay"] = "OloPay";
	PaymentProcessor["ParPayWP"] = "ParPay WP";
	PaymentProcessor["RevelAdvantage"] = "Revel Advantage";
	PaymentProcessor["Shift4"] = "Shift4";
	PaymentProcessor["Stripe"] = "Stripe";
	PaymentProcessor["TdCanada"] = "TD Canada";
	PaymentProcessor["TsysSierra"] = "TSYS (Sierra)";
	PaymentProcessor["Worldpay"] = "Worldpay";
	return PaymentProcessor;
}({});
//#endregion
export { PaymentProcessor };

//# sourceMappingURL=payment_processor.js.map